import { IPortalActivity } from './types';

export const convertActivity = (data: IPortalActivity<string>): IPortalActivity<Date> => ({
  ...data,
  created_at: new Date(data.created_at),
  updated_at: new Date(data.updated_at),
  start_date: data.start_date ? new Date(data.start_date) : undefined,
  end_date: data.end_date ? new Date(data.end_date) : undefined,
});
